import React, { createContext, useState, useEffect, useContext } from 'react';
import {resizeProzorDimenzije, updateProzorDimenzije} from "../utils/helpers/ProzorDimenzije";

// Kreiraj Context za dimenzije
const ProzorDimenzijeContext = createContext({});

declare global {

    interface Window {
        ProzorDimenzije:any;
    }
}

// Provider za dimenzije
export const ProzorDimenzijeProvider = ({ children }:any) => {
    const [prozorDimenzije, setProzorDimenzije] = useState({
        vidljivaSirina: window.innerWidth,
        vidljivaVisina: window.innerHeight,
        preglednikSirina: window.outerWidth,
        preglednikVisina: window.outerHeight,
        ukupnaSirina: document.documentElement.scrollWidth,
        ukupnaVisina: document.documentElement.scrollHeight
    });

    // Funkcija za ažuriranje dimenzija na resize
    useEffect(() => {
        window.addEventListener("resize", () => updateProzorDimenzije(setProzorDimenzije));
        return () => window.removeEventListener("resize", () => updateProzorDimenzije(setProzorDimenzije));
    }, []);

    useEffect(() => {
        resizeProzorDimenzije(prozorDimenzije);
    },[prozorDimenzije]);


    return (
        <ProzorDimenzijeContext.Provider value={prozorDimenzije}>
            {children}
            </ProzorDimenzijeContext.Provider>
    );
};

// Custom Hook za pristup dimenzijama
export const useProzorDimenzije = () => {
    return useContext(ProzorDimenzijeContext);
};
